<template>
  <div class="my-loading">
    <van-overlay :show="show">
      <div class="loading-wrap">
        <van-loading type="spinner" vertical>加载中...</van-loading>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { Loading, Overlay } from "vant";
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    show(v) {
      this.show = v;
    },
  },
  components: {
    "van-loading": Loading,
    "van-overlay": Overlay,
  },
};
</script>

<style lang="less" scoped>
.my-loading {
  ::v-deep .van-overlay {
    z-index: 9999;
  }
  .loading-wrap {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
